import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import { ViewerContext } from 'common/containers/ViewerContainer';
import JiraLandingHelmet from 'common/helmets/JiraLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import withContexts from 'common/util/withContexts';
import Jira1 from 'img/landing/jira-1.webp';
import Jira2 from 'img/landing/jira-2.webp';
import Jira3 from 'img/landing/jira-3.webp';

import JiraLogo from 'img/canny-jira-integration.png';

import 'css/components/integrations/_IntegrationsLanding.scss';
import 'css/components/_LandingFeatures.scss';

class JiraLanding extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
    viewer: PropTypes.shape({
      companies: PropTypes.array,
    }),
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Jira Integration Page');
  }

  render() {
    return (
      <div className="integrationsLanding">
        <JiraLandingHelmet />
        <div className="integrationsLandingContainer">
          <div className="header">
            <div className="left">
              <LazyLoadedImage className="appLogo" loading="eager" src={JiraLogo} />
              <div className="text">
                <h1 className="title">Canny for Jira</h1>
                <div className="subtitle">Sync feedback between Canny and&nbsp;Jira</div>
                <div className="links">
                  <InstallExtensionButton
                    installButtonText="Install Jira"
                    installLink="https://marketplace.atlassian.com/apps/1217889/canny-for-jira"
                  />
                  <a
                    href="http://help.canny.io/en/articles/1283233-jira-integration"
                    rel="noopener"
                    target="_blank"
                    className="LandingIntegrations__install-link">
                    See install docs
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="features">
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" loading="eager" src={Jira1} />
              </div>
              <div className="featureText">
                <div className="title">Link Canny posts with Jira&nbsp;issues</div>
                <div className="subtitle">
                  Push issues from Canny to Jira and link between the&nbsp;two.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Jira2} />
              </div>
              <div className="featureText">
                <div className="title">Push posts to&nbsp;Jira</div>
                <div className="subtitle">
                  See a great idea in Canny? Push it over to Jira as an issue and automatically link
                  them&nbsp;together.
                </div>
              </div>
            </div>
            <div className="featureHighlight">
              <div className="featureImage">
                <LazyLoadedImage className="shadow" src={Jira3} />
              </div>
              <div className="featureText">
                <div className="title">Keep statuses in&nbsp;sync</div>
                <div className="subtitle">
                  No more worrying about losing track of status updates. Create rules to
                  automatically sync statuses between Jira and&nbsp;Canny.
                </div>
              </div>
            </div>
          </div>
          <LandingFooterCTA style="solid" />
        </div>
      </div>
    );
  }
}

export default withContexts({
  trackEvent: TrackEventContext,
  viewer: ViewerContext,
})(JiraLanding);
